import { FC, useReducer } from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as ExclamationIcon } from 'src/assets/icons/exclamation.svg';
import { CleanButton } from 'src/common/components/Button';
import { media } from 'src/common/styles/breakpoints';
import { IntlFormattedMessage } from 'src/common/components/IntlFormattedMessage';

const Container = styled.div<{ $fullLabel: boolean }>`
  margin-top: 2.5rem;
  display: flex;
  padding: 1rem;
  background-color: ${({ theme }) => theme.text.primary};
  border-radius: 0.5rem;
`;

const Paragraph = styled.p`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.white};
  margin-top: 1rem;
`;

const Title = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.85rem;

  ${media.w.min.px576(css`
    font-size: 1rem;
  `)}
`;

const Icon = styled(ExclamationIcon)`
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
  margin-right: 1rem;
  color: ${({ theme }) => theme.colors.primary};
`;

const ToggleLabelButton = styled(CleanButton)`
  font-weight: bold;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.primary} !important;
  &:hover {
    text-decoration: underline;
  }

  &:focus,
  &:active {
    outline: 2px solid currentColor;
    outline-offset: 1px;
  }
`;

const MainPageAlert: FC = () => {
  const [fullLabel, toggleFullLabel] = useReducer(
    (previous) => !previous,
    false
  );

  return (
    <Container $fullLabel={fullLabel}>
      <Icon />
      <div>
        <Title>
          <IntlFormattedMessage id="data.alert.heading" />{' '}
          {!fullLabel && (
            <ToggleLabelButton onClick={toggleFullLabel}>
              <IntlFormattedMessage id="common.more" />
            </ToggleLabelButton>
          )}
        </Title>
        {fullLabel && (
          <>
            <Paragraph>
              <IntlFormattedMessage id="data.alert.p1" />{' '}
            </Paragraph>
            <Paragraph>
              <IntlFormattedMessage id="data.alert.p2" />
            </Paragraph>
            <ToggleLabelButton
              onClick={toggleFullLabel}
              style={{ fontSize: '0.75rem' }}
            >
              <IntlFormattedMessage id="common.less" />
            </ToggleLabelButton>
          </>
        )}
      </div>
    </Container>
  );
};

export default MainPageAlert;
